import React from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #F8F9FA 0%, #E8F5E9 100%)',
    fontFamily: "'Inter', sans-serif",
    color: '#1B3A5F',
    lineHeight: 1.7,
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '60px 40px',
    background: 'white',
    minHeight: '100vh',
    boxShadow: '0 0 40px rgba(0,0,0,0.1)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '30px',
    borderBottom: '3px solid #00B4A2',
  },
  logo: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#2D5A45',
    letterSpacing: '2px',
    marginBottom: '20px',
    textTransform: 'uppercase',
  },
  h1: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '42px',
    fontWeight: 300,
    color: '#1B3A5F',
    margin: '0 0 15px 0',
  },
  updated: {
    fontSize: '14px',
    color: '#6B7A8F',
    margin: 0,
  },
  section: {
    marginBottom: '40px',
  },
  h2: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '24px',
    fontWeight: 600,
    color: '#2D5A45',
    margin: '40px 0 20px 0',
    paddingBottom: '10px',
    borderBottom: '2px solid #E5E7EB',
  },
  h3: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#1B3A5F',
    margin: '25px 0 15px 0',
  },
  p: {
    fontSize: '16px',
    marginBottom: '15px',
    color: '#1B3A5F',
  },
  ul: {
    marginBottom: '20px',
    paddingLeft: '25px',
  },
  li: {
    fontSize: '16px',
    marginBottom: '10px',
    color: '#1B3A5F',
  },
  legalFooter: {
    background: '#F8F9FA',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: '25px',
    marginTop: '50px',
    textAlign: 'center',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '30px',
    borderTop: '1px solid #E5E7EB',
  },
  link: {
    color: '#2D5A45',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '16px',
  },
  inlineLink: {
    color: '#00B4A2',
    textDecoration: 'none',
  },
  contactBox: {
    background: '#E8F5E9',
    borderLeft: '4px solid #2D5A45',
    borderRadius: '0 8px 8px 0',
    padding: '20px 25px',
    margin: '20px 0',
  },
};

function Privacy() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.logo}>PASS Profile™ 3.0</div>
          <h1 style={styles.h1}>Privacy Policy</h1>
          <p style={styles.updated}>Last Updated: January 24, 2026</p>
        </div>
        
        <div style={styles.section}>
          <h2 style={styles.h2}>Introduction</h2>
          <p style={styles.p}>
            Ted's Voice Academy ("we," "our," "us") respects your privacy. This Privacy 
            Policy explains how we collect, use, store, and protect your information 
            when you use the PASS Profile 3.0 assessment.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Information We Collect</h2>
          
          <h3 style={styles.h3}>Information You Provide:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Account Information:</strong> Name, email address, password</li>
            <li style={styles.li}><strong>Payment Information:</strong> Processed securely by Stripe (we never see your full credit card number)</li>
            <li style={styles.li}><strong>Assessment Responses:</strong> Your answers to 60 scenario-based questions</li>
          </ul>
          
          <h3 style={styles.h3}>Automatically Collected:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Usage Data:</strong> When you log in, complete the assessment, download your report</li>
            <li style={styles.li}><strong>Technical Data:</strong> IP address, browser type, device information</li>
            <li style={styles.li}><strong>Cookies:</strong> Session cookies to keep you logged in</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>How We Use Your Information</h2>
          <p style={styles.p}>We use your data to:</p>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Deliver the Service:</strong> Process your answers and build your report</li>
            <li style={styles.li}><strong>Communicate:</strong> Send you your results, respond to support requests</li>
            <li style={styles.li}><strong>Improve:</strong> Analyze aggregate data to enhance the assessment</li>
            <li style={styles.li}><strong>Legal Compliance:</strong> Meet legal obligations</li>
          </ul>
          
          <p style={styles.p}>We do NOT:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Sell your personal information</li>
            <li style={styles.li}>Share your individual results without consent</li>
            <li style={styles.li}>Use your data for unrelated marketing</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>How We Store Your Data</h2>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Security:</strong> Industry-standard encryption (HTTPS, encrypted database)</li>
            <li style={styles.li}><strong>Location:</strong> Servers in the United States (Supabase infrastructure)</li>
            <li style={styles.li}><strong>Retention:</strong> We keep your data as long as your account is active</li>
            <li style={styles.li}><strong>Deletion:</strong> You can request account deletion at any time</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Data Sharing</h2>
          <p style={styles.p}>We share data only with:</p>
          
          <h3 style={styles.h3}>Service Providers:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Supabase:</strong> Database and authentication</li>
            <li style={styles.li}><strong>Stripe:</strong> Payment processing</li>
            <li style={styles.li}><strong>Resend:</strong> Email delivery for sending reports</li>
            <li style={styles.li}><strong>Anthropic:</strong> AI writing assistance for parts of your report text. We remove your name before anything is sent, and we never send your contact or payment details. Under Anthropic's business terms, this information is not used to train its AI models.</li>
          </ul>
          <p style={styles.p}>These providers are contractually obligated to protect your data.</p>

          <h3 style={styles.h3}>Team Reports:</h3>
          <p style={styles.p}>If you are a member of a team that orders a Team Dynamics Alignment report, that report shows your team the communication approaches your answers favored. Each member of the team receives a copy of the report by email. It does not show your answers or any scores.</p>
          
          <h3 style={styles.h3}>We Never Share With:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Advertisers</li>
            <li style={styles.li}>Data brokers</li>
            <li style={styles.li}>Third-party marketers</li>
            <li style={styles.li}>Social media companies</li>
          </ul>
          
          <h3 style={styles.h3}>Legal Requirements:</h3>
          <p style={styles.p}>We may disclose data if required by law, court order, or to:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Protect safety</li>
            <li style={styles.li}>Prevent fraud</li>
            <li style={styles.li}>Comply with legal process</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Your Rights</h2>
          <p style={styles.p}>You have the right to:</p>
          
          <h3 style={styles.h3}>Access:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>View all data we have about you</li>
            <li style={styles.li}>Download your assessment results anytime</li>
          </ul>
          
          <h3 style={styles.h3}>Correction:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Update your account information</li>
            <li style={styles.li}>Correct inaccuracies</li>
          </ul>
          
          <h3 style={styles.h3}>Deletion:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Delete your account</li>
            <li style={styles.li}>Request erasure of all your data (we'll comply within 30 days)</li>
          </ul>
          
          <h3 style={styles.h3}>Portability:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Export your assessment results</li>
            <li style={styles.li}>Download your data in machine-readable format</li>
          </ul>
          
          <h3 style={styles.h3}>Object:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Opt out of marketing emails (transactional emails still sent)</li>
            <li style={styles.li}>Object to data processing (may affect service availability)</li>
          </ul>
          
          <p style={styles.p}><strong>To exercise these rights:</strong> Email <a href="mailto:PASS@tedsvoiceacademy.com" style={styles.inlineLink}>PASS@tedsvoiceacademy.com</a></p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Cookies</h2>
          <p style={styles.p}>We use cookies for:</p>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Essential:</strong> Keep you logged in</li>
            <li style={styles.li}><strong>Analytics:</strong> Understand how the assessment is used (aggregated, anonymized)</li>
          </ul>
          <p style={styles.p}>You can disable cookies in your browser, but the Service may not function properly.</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Children's Privacy</h2>
          <p style={styles.p}>
            PASS Profile is not intended for anyone under 18. We do not knowingly collect 
            data from children. If we discover we have, we'll delete it immediately.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>International Users</h2>
          <p style={styles.p}>If you're outside the United States:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Your data is stored in the US</li>
            <li style={styles.li}>By using the Service, you consent to transfer</li>
            <li style={styles.li}>We comply with GDPR for EU residents</li>
            <li style={styles.li}>Contact us about your specific rights</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Changes to Privacy Policy</h2>
          <p style={styles.p}>We may update this policy. We'll notify you of significant changes via:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Email to your registered address</li>
            <li style={styles.li}>Notice on the website</li>
          </ul>
          <p style={styles.p}>Continued use after changes means you accept the updated policy.</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>California Residents (CCPA)</h2>
          <p style={styles.p}>If you're a California resident, you have additional rights:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Right to know what data we collect</li>
            <li style={styles.li}>Right to deletion</li>
            <li style={styles.li}>Right to opt-out of sale (we don't sell data)</li>
            <li style={styles.li}>Right to non-discrimination</li>
          </ul>
          <p style={styles.p}>Contact us to exercise these rights.</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>European Users (GDPR)</h2>
          <p style={styles.p}>If you're in the EU/EEA:</p>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Legal Basis:</strong> Contract performance, legitimate interest</li>
            <li style={styles.li}><strong>Data Protection Officer:</strong> Not required for our size, but contact PASS@tedsvoiceacademy.com</li>
            <li style={styles.li}><strong>Right to Lodge Complaint:</strong> Contact your local data protection authority</li>
            <li style={styles.li}><strong>Data Transfers:</strong> We use Standard Contractual Clauses</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Data Breach Notification</h2>
          <p style={styles.p}>If a breach affects your data, we'll notify you within 72 hours and explain:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>What happened</li>
            <li style={styles.li}>What data was affected</li>
            <li style={styles.li}>What we're doing about it</li>
            <li style={styles.li}>What you should do</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Contact Us</h2>
          <div style={styles.contactBox}>
            <p style={{...styles.p, marginBottom: '10px'}}><strong>Privacy Questions:</strong></p>
            <p style={{...styles.p, marginBottom: '5px'}}>Email: <a href="mailto:PASS@tedsvoiceacademy.com" style={styles.inlineLink}>PASS@tedsvoiceacademy.com</a></p>
            <p style={{...styles.p, marginBottom: '20px'}}>Mail: Ted's Voice Academy, Lacey, WA 98503</p>
            
            <p style={{...styles.p, marginBottom: '10px'}}><strong>General Support:</strong></p>
            <p style={{...styles.p, marginBottom: '5px'}}>Email: <a href="mailto:ted@tedsvoiceacademy.com" style={styles.inlineLink}>ted@tedsvoiceacademy.com</a></p>
            <p style={{...styles.p, marginBottom: 0}}>Website: <a href="https://tedsvoiceacademy.com" style={styles.inlineLink}>www.tedsvoiceacademy.com</a></p>
          </div>
        </div>

        <div style={styles.legalFooter}>
          <p style={{...styles.p, marginBottom: 0}}>
            <strong>This Privacy Policy is effective as of January 24, 2026.</strong>
          </p>
        </div>

        <div style={styles.backLink}>
          <a href="/" style={styles.link}>← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
